// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { LogOut } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconLogOut(props: any) {
    return <IconBase icon={LogOut} {...props} />
  }

  export default IconLogOut
  